import React from 'react';
import './style.scss';
import clsx from 'clsx';
import CustomCheckbox from '../../../../Shared/components/controls/Checkbox';

const CardsListCardSelector = ({ isSelected, onClick, className, t }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onClick(e);
  };

  return (
    <div
      className={clsx('cards-list-card-selector', isSelected && 'clc-selector-active', className)}
      onClick={handleClick}
    >
      <CustomCheckbox checked={isSelected} className={'clc-selector-checkbox'} />
      {t('Compare')}
    </div>
  );
};

export default CardsListCardSelector;
